import { CtaBanner } from "../ui/cta-banner";

interface BottomCTAProps {
  itemCount: number;
  itemTypePlural: string;
  breakdownName: string;
  breakdownTypeSlug: string;
  joinAsLinkUrl: string;
  joinAsLinkText: string;
  mainCtaSubTextTemplate: string;
  mainCtaButtonTextTemplate: string;
  utmCampaignPrefix: string;
}

export const BottomCTA = ({
  itemCount,
  itemTypePlural,
  breakdownName,
  breakdownTypeSlug,
  joinAsLinkUrl,
  joinAsLinkText,
  mainCtaSubTextTemplate,
  mainCtaButtonTextTemplate,
  utmCampaignPrefix,
}: BottomCTAProps) => {
  const mainCtaSubText = mainCtaSubTextTemplate.replace("{}", breakdownName);
  const mainCtaButtonText = mainCtaButtonTextTemplate.replace(
    "{}",
    breakdownName,
  );

  return (
    <div className="mt-12 flex flex-col items-center justify-center gap-4 text-center text-sm">
      <p className="text-text-secondary">
        {itemCount > 0
          ? `Showing ${itemCount} ${itemTypePlural} in ${breakdownName}.`
          : `Be the first ${breakdownName} ${itemTypePlural.slice(0, -1)} listed!`}{" "}
        <a
          href={joinAsLinkUrl}
          className="text-text-primary font-semibold underline transition-colors hover:no-underline"
        >
          {joinAsLinkText}
        </a>
      </p>
      <div className="w-full max-w-prose">
        <CtaBanner
          headline={mainCtaSubText}
          buttonText={mainCtaButtonText}
          buttonHref={`/discovery?utm_campaign=${utmCampaignPrefix}&utm_source=${breakdownTypeSlug}`}
        >
          <div className="mt-4">
            <a
              href="/page/member"
              className="my-2 text-center text-xs text-purple-200/70 underline transition-colors hover:text-white hover:no-underline"
            >
              How does Dream Coach Match work?
            </a>
          </div>
        </CtaBanner>
      </div>
    </div>
  );
};
